import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { TagStore } from '../../../stores/tag/tag.state';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-tag-filter-dropdown',
  standalone: true,
  imports: [MultiSelectModule, NgIf, SharedModule, FormsModule],
  templateUrl: './tag-filter-dropdown.component.html',
  styleUrl: './tag-filter-dropdown.component.scss',
})
export class TagFilterDropdownComponent implements OnInit, OnDestroy {
  readonly tagStore = inject(TagStore);

  @Input() styleClass = '';
  @Input() label = 'Schlagworte';
  @Input() selectedTags?: string[] = [];
  @Input() selectedProducts?: string[] = [];
  @Input() tagsInUse?: string[];
  @Output() selectedTagsChange = new EventEmitter<string[]>();

  /**
   * Initializes the component and sets up necessary configurations.
   * If `tagsInUse` is defined, it updates the filter in the tag store
   * using the provided tag identifiers.
   *
   * @return {void} No return value.
   */
  ngOnInit(): void {
    if (this.tagsInUse) {
      this.tagStore.updateFilter({ ids: this.tagsInUse });
    }
  }

  /**
   * Handles changes to the selected tags by emitting the updated list of tags after a short delay.
   *
   * @return {void} This method does not return a value.
   */
  onTagsChange(): void {
    setTimeout(() => {
      this.selectedTagsChange.emit(this.selectedTags);
    }, 10);
  }

  /**
   * Angular lifecycle hook that is called when the component is destroyed.
   * Performs necessary cleanup operations, such as clearing any applied filters on the tag store.
   *
   * @return {void} This method does not return a value.
   */
  ngOnDestroy(): void {
    this.tagStore.clearFilter();
  }
}
